import { render, staticRenderFns } from "./MessageTemplate.modal.vue?vue&type=template&id=5b5ec2db&scoped=true&"
import script from "./MessageTemplate.modal.vue?vue&type=script&lang=js&"
export * from "./MessageTemplate.modal.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplate.modal.vue?vue&type=style&index=0&id=5b5ec2db&prod&lang=scss&scoped=true&"
import style1 from "./MessageTemplate.modal.vue?vue&type=style&index=1&id=5b5ec2db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ec2db",
  null
  
)

export default component.exports